import React, { Component } from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import { withRouter, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Adsense } from '@ctrl/react-adsense';

const styles = theme => ({
  root: {
  }
})

class Home extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      title: "",
      desc: "",
      nag_label: "",
      pos_label: "",
      linkto: ""
    };
  }


  handleClose = value => {
    this.setState({ open: false });
  };

  logout = () => {
    localStorage.removeItem("token")
  }

  renderLogin() {
    let token = localStorage.getItem("token")
    let id = localStorage.getItem("id")
    if (token != null) {
      return <Link to="/" className="nav-link btn btn-primary btn-lg btn" onClick={this.logout}> {id} 登出</Link>
    } else {
      return <Link to="/sign_in" className="nav-link btn btn-primary btn-lg btn">登入</Link>
    }
  }


  render() {
    return (
      <div>
        <Helmet>
          {/* <script src="assets/web/assets/jquery/jquery.min.js"></script>
           <script src="assets/tether/tether.min.js"></script>
           <script src="assets/bootstrap/js/bootstrap.min.js"></script> */}


          <script
            src="https://code.jquery.com/jquery-1.11.2.min.js"
            integrity="sha256-Ls0pXSlb7AYs7evhd+VLnWsZ/AqEHcXBeMZUycz/CcA="
            crossorigin="anonymous"></script>
          {/* <script src="assets/tether/tether.min.js"></script> */}
          <script src="https://npmcdn.com/tether@1.2.4/dist/js/tether.min.js"></script>
          <script src="https://npmcdn.com/bootstrap@4.0.0-alpha.2/dist/js/bootstrap.min.js"></script>


          <script src="assets/smooth-scroll/smooth-scroll.js"></script>
          <script src="assets/dropdown/js/script.min.js"></script>
          {/* <script src="assets/touch-swipe/jquery.touch-swipe.min.js"></script>
           <script src="assets/theme/js/script.js"></script> */}


          <script src="assets/formoid/formoid.min.js"></script>
        </Helmet>


        <meta charSet="UTF-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="generator" content="Mobirise v4.10.8, mobirise.com" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, minimum-scale=1"
        />
        <link
          rel="shortcut icon"
          href="assets/images/512x512-128x128.png"
          type="image/x-icon"
        />
        <meta name="description" content="股票挖土機" />
        <title>首頁</title>
        <link
          rel="stylesheet"
          href="assets/web/assets/mobirise-icons/mobirise-icons.css"
        />
        {/* <link
    rel="stylesheet"
    href="https://fonts.googleapis.com/css?family=Libre+Franklin:400,400i,600,600i"
  /> */}
        <link rel="stylesheet" href="assets/tether/tether.min.css" />
        <link rel="stylesheet" href="assets/bootstrap/css/bootstrap.min.css" />
        <link rel="stylesheet" href="assets/shopping-cart/minicart-theme.css" />
        <link rel="stylesheet" href="assets/dropdown/css/style.css" />
        <link rel="stylesheet" href="assets/theme/css/style.css" />
        <link rel="stylesheet" href="assets/formoid/recaptcha.css" />
        <link
          rel="stylesheet"
          href="assets/mobirise/css/mbr-additional.css"
          type="text/css"
        />
        <meta name="theme-color" content="#5aac98" />
        <link rel="manifest" href="manifest.json" />
        <section className="menu1" id="menu1-c" data-rv-view={784}>
          <nav className="navbar navbar-dropdown">
            <div className="container-fluid">
              <div className="mbr-table">
                <div className="mbr-table-cell logo">
                  <div className="navbar-brand">
                    <a href="https://stock-digger.com" className="navbar-logo">
                      <img
                        src="assets/images/512x512-128x128.png"
                        alt="股票挖土機"
                        style={{ height: "3.5rem", width: "3.5rem" }}
                      />
                    </a>
                    <a className="navbar-caption" href="https://stock-digger.com">
                      股票挖土機
                    </a>
                  </div>
                </div>
                <div className="mbr-table-cell text">
                  <button
                    className="navbar-toggler pull-xs-right hidden-md-up"
                    type="button"
                    data-toggle="collapse"
                    data-target="#exCollapsingNavbar"
                  >
                    <div className="hamburger-icon" />
                  </button>
                  <ul
                    className="nav-dropdown collapse pull-xs-right nav navbar-nav navbar-toggleable-sm"
                    id="exCollapsingNavbar"
                  >
                    <li className="nav-item">
                      <Link to="/" className="nav-link link">首頁</Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/rules" className="nav-link link">輕鬆挖股票</Link>
                    </li>
                  </ul>
                  <button
                    hidden
                    className="navbar-toggler navbar-close"
                    type="button"
                    data-toggle="collapse"
                    data-target="#exCollapsingNavbar"
                  >
                    <div className="close-icon" />
                  </button>
                </div>
              </div>
            </div>
          </nav>
        </section>
        <section
          className="mbr-section content5 mbr-after-navbar"
          id="content5-1i"
          data-rv-view={759}
          style={{
            background:
              "linear-gradient(to right top, rgb(25, 182, 143), rgb(68, 100, 148)) rgb(25, 182, 143)",
            paddingTop: 120,
            paddingBottom: 40
          }}
        >
          <div className="container">
            <div className="row heading">
              <div className="col-md-10 text-xs-center col-md-offset-1">
                <h1 className="mbr-section-title display-1 heading-title">
                  <strong>股票挖土機</strong>
                </h1>
                <p className="mbr-section-subtitle text-1 heading-text">
                  簡易的操作介面、快速的搜尋計算、眾多的股票資訊表格
                  <br />
                  將自己的投資理念轉換成幾條簡單的文字規則，讓您從近2000支的股票與ETF中，快速的挖出珍貴的投資標的。
                </p>
                <div className="mbr-section-btn">
                  <Link to="/rules" className="btn btn-lg btn-primary">輕鬆挖股票</Link>
                  {/* <a className="btn btn-lg btn-primary"  onClick={() => window.location.assign( 'http://localhost:3000/#/rules')}>輕鬆挖股票</a> */}
                </div>
              </div>
            </div>
          </div>
        </section>
        <section 
          className="mbr-section"
          style={{
            backgroundColor: "rgb(255, 255, 253)",
            paddingTop: 40,
            paddingBottom: 40
          }}
        >
          <div className="container">
            <div className="row">
              {/* 左邊：股票挖土機3.0改版計畫 */}
              <div 
                className="col-xs-12 col-md-6"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '20px',
                  minHeight: '300px'
                }}
              >
                <div 
                  style={{
                    textAlign: 'center',
                    padding: '30px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    width: '100%',
                    maxWidth: '400px'
                  }}
                >
                  <h3 
                    style={{
                      color: '#2c3e50',
                      marginBottom: '20px',
                      fontSize: '24px',
                      fontWeight: 'bold'
                    }}
                  >
                    股票挖土機3.0改版計畫開始了
                  </h3>
                  <p 
                    style={{
                      color: '#34495e',
                      fontSize: '16px',
                      lineHeight: '1.6',
                      marginBottom: '20px'
                    }}
                  >
                    早鳥跟無使用期限方案也開啟了
                  </p>
                  <a 
                    href="https://tw.stock-digger.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-block',
                      padding: '12px 24px',
                      backgroundColor: '#3498db',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '6px',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      transition: 'background-color 0.3s'
                    }}
                  >
                    立即查看
                  </a>
                </div>
              </div>

              {/* 右邊：美股挖土機嘖嘖募資 */}
              <div 
                className="col-xs-12 col-md-6"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '20px',
                  minHeight: '300px'
                }}
              >
                <div 
                  style={{
                    textAlign: 'center',
                    padding: '30px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    width: '100%',
                    maxWidth: '400px'
                  }}
                >
                  <h3 
                    style={{
                      color: '#2c3e50',
                      marginBottom: '20px',
                      fontSize: '24px',
                      fontWeight: 'bold'
                    }}
                  >
                    美股挖土機
                  </h3>
                  <p 
                    style={{
                      color: '#34495e',
                      fontSize: '16px',
                      lineHeight: '1.6',
                      marginBottom: '20px'
                    }}
                  >
                    專為美股投資者打造的選股工具
                  </p>
                  <div style={{ marginBottom: '15px' }}>
                   <a 
                    href="https://us.stock-digger.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-block',
                      padding: '12px 24px',
                      backgroundColor: '#27ae60',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '6px',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      transition: 'background-color 0.3s'
                    }}
                  >
                    美股挖土機官網
                  </a> 
                  </div>
                  <a 
                      href="https://www.zeczec.com/projects/us-stock-digger"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: 'inline-block',
                        padding: '12px 24px',
                        backgroundColor: '#e74c3c',
                        color: 'white',
                        textDecoration: 'none',
                        borderRadius: '6px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        marginBottom: '10px',
                        transition: 'background-color 0.3s'
                      }}
                    >
                      嘖嘖募資頁面
                    </a>
                  
                </div>
              </div>
            </div>
          </div>
        </section>
        <Adsense
          client="ca-pub-8613274553211553"
          slot="5934285082"
          style={{ display: 'block' }}
          layout="in-article"
          format="auto"
        />

        <section
          className="mbr-section mbr-section-hero features2"
          id="features2-2"
          data-rv-view={764}
          style={{
            backgroundColor: "rgb(255, 255, 253)",
            paddingTop: 40,
            paddingBottom: 80
          }}
        >
          <div className="container">
            <div className="row heading">
              <div className="col-md-12">
                <h1 className="mbr-section-title display-3 heading-title">
                  <strong>挖土機的特色</strong>
                </h1>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="col-xs-12">
              <div className="row">
                <div className="mbr-cards-col col-xs-12 col-lg-3">
                  <div className="card" style={{ textAlign: "left" }}>
                    <div
                      className="card-img col-xs-3 col-lg-12"
                      style={{ textAlign: "left" }}
                    >
                      <div
                        className="mbri-hot-cup mbr-iconfont"
                        style={{ fontSize: 40 }}
                      />
                    </div>
                    <div className="card-box col-xs-9 col-lg-12">
                      <h4 className="card-title mbr-section-subtitle sub-2">
                        免註冊
                      </h4>
                      <p className="card-text mbr-section-text text-1">
                        使用上完全沒有負擔，所有資料盡量完全公開並且免費，只有在特殊查詢的條件才需要付費。
                      </p>
                    </div>
                    <div className="clear" />
                  </div>
                </div>
                <div className="mbr-cards-col col-xs-12 col-lg-3">
                  <div className="card" style={{ textAlign: "left" }}>
                    <div
                      className="card-img col-xs-3 col-lg-12"
                      style={{ textAlign: "left" }}
                    >
                      <div
                        className="mbri-speed mbr-iconfont"
                        style={{ fontSize: 40 }}
                      />
                    </div>
                    <div className="card-box col-xs-9 col-lg-12">
                      <h4 className="card-title mbr-section-subtitle sub-2">
                        超快的挖掘
                      </h4>
                      <p className="card-text mbr-section-text text-1">
                        每一次的挖掘僅用1~2秒，就會將結果呈現給出來，大量地減少浪費您的寶貴時間。
                      </p>
                    </div>
                    <div className="clear" />
                  </div>
                </div>
                <div className="mbr-cards-col col-xs-12 col-lg-3">
                  <div className="card" style={{ textAlign: "left" }}>
                    <div
                      className="card-img col-xs-3 col-lg-12"
                      style={{ textAlign: "left" }}
                    >
                      <div
                        className="mbri-touch mbr-iconfont"
                        style={{ fontSize: 40 }}
                      />
                    </div>
                    <div className="card-box col-xs-9 col-lg-12">
                      <h4 className="card-title mbr-section-subtitle sub-2">
                        超簡單的設定
                      </h4>
                      <p className="card-text mbr-section-text text-1">
                        所有投資規則都是利用簡單的文字來設定，一方面減低學習的曲線，並能簡單發現的好公司。
                      </p>
                    </div>
                    <div className="clear" />
                  </div>
                </div>
                <div className="mbr-cards-col col-xs-12 col-lg-3">
                  <div className="card" style={{ textAlign: "left" }}>
                    <div
                      className="card-img col-xs-3 col-lg-12"
                      style={{ textAlign: "left" }}
                    >
                      <div
                        className="mbri-setting mbr-iconfont"
                        style={{ fontSize: 40 }}
                      />
                    </div>
                    <div className="card-box col-xs-9 col-lg-12">
                      <h4 className="card-title mbr-section-subtitle sub-2">
                        超彈性的組合
                      </h4>
                      <p className="card-text mbr-section-text text-1">
                        所有的基本面、技術面、籌碼面都可以非常有彈性的混合使用，用最嚴苛的條件找到好公司。
                        <br />
                      </p>
                    </div>
                    <div className="clear" />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
        <section
          className="mbr-section mbr-section-hero header3 header7"
          id="header7-1j"
          data-rv-view={767}
          style={{
            paddingTop: 50,
            paddingBottom: 50,
            background:
              "linear-gradient(20deg, rgb(191, 53, 157), rgb(220, 76, 53), rgb(253, 255, 129)) rgb(191, 53, 157)"
          }}
        >
          <div className="mbr-table mbr-table-full">
            <div className="mbr-table-cell">
              <div className="container">
                <div className="row">
                  <div className="mbr-table-md-up">
                    <div
                      className="mbr-table-cell mbr-right-padding-md-up mbr-valign-top col-md-7 image-size"
                      style={{ width: "30%" }}
                    >
                      <div className="mbr-figure">
                        <img src="assets/images/mbr-1400x933.jpg" />
                      </div>
                    </div>
                    <div className="mbr-table-cell col-md-5 text-xs-center text-md-left">
                      <h3 className="mbr-section-title display-2">
                        <strong>投資規則</strong>
                        <strong>自由搭配</strong>
                      </h3>
                      <div className="mbr-section-text"></div>
                      <div className="mbr-section-btn">
                        <Link to="/rules" className="btn btn-lg btn-primary">立即去挖股票</Link>
                        {/* <a
                    className="btn btn-lg btn-primary"
                    href="https://p.ecpay.com.tw/5C4E5#price"
                    target="_blank"
                  >
                    喜歡挖土機，請支持我們
                  </a> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="mbr-section mbr-section-hero features16"
          id="features16-a"
          data-rv-view={770}
          style={{
            backgroundColor: "rgb(255, 255, 253)",
            paddingTop: 120,
            paddingBottom: 40
          }}
        >
          <div className="container">
            <div className="row heading">
              <div className="col-md-12">
                <h1 className="mbr-section-title display-3 heading-title">
                  <strong>挖土機的組合元素</strong>
                </h1>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="col-xs-12">
              <div className="row">
                <div className="mbr-cards-col col-xs-12 col-lg-4">
                  <div className="card" style={{ textAlign: "center" }}>
                    <div
                      className="card-img col-xs-3 col-lg-12"
                      style={{ textAlign: "center" }}
                    >
                      <div className="mbr-iconfont">
                        <span>
                          <font color="#ffffff">合理</font>
                        </span>
                      </div>
                    </div>
                    <div className="card-box col-xs-9 col-lg-12">
                      <h4 className="card-title mbr-section-subtitle sub-2">
                        合理價判斷
                      </h4>
                      <p className="card-text mbr-section-text text-1">
                        利用自由現金流或股息計算出合理的價格，一眼看出目前價格是昂貴或者便宜。
                      </p>
                    </div>
                    <div className="clear" />
                  </div>
                </div>
                <div className="mbr-cards-col col-xs-12 col-lg-4">
                  <div className="card" style={{ textAlign: "center" }}>
                    <div
                      className="card-img col-xs-3 col-lg-12"
                      style={{ textAlign: "center" }}
                    >
                      <div className="mbr-iconfont">
                        <span>
                          <p>籌碼</p>
                        </span>
                      </div>
                    </div>
                    <div className="card-box col-xs-9 col-lg-12">
                      <h4 className="card-title mbr-section-subtitle sub-2">
                        大戶主力籌碼表
                      </h4>
                      <p className="card-text mbr-section-text text-1">
                        隨時可以了解最近主力、大戶、外資、投信、自營商籌碼的變化。
                      </p>
                    </div>
                    <div className="clear" />
                  </div>
                </div>
                <div className="mbr-cards-col col-xs-12 col-lg-4">
                  <div className="card" style={{ textAlign: "center" }}>
                    <div
                      className="card-img col-xs-3 col-lg-12"
                      style={{ textAlign: "center" }}
                    >
                      <div className="mbr-iconfont">
                        <span>
                          <p>回測</p>
                        </span>
                      </div>
                    </div>
                    <div className="card-box col-xs-9 col-lg-12">
                      <h4 className="card-title mbr-section-subtitle sub-2">
                        回測系統
                      </h4>
                      <p className="card-text mbr-section-text text-1">
                        好的股票策略需要回測系統來驗證
                        <br />
                      </p>
                    </div>
                    <div className="clear" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="mbr-section content5"
          id="content7-7"
          data-rv-view={773}
          style={{
            backgroundImage: "url(assets/images/content7.jpg)",
            paddingTop: 80,
            paddingBottom: 100
          }}
        >
          <div
            className="mbr-overlay"
            style={{ opacity: "0.5", backgroundColor: "rgb(45, 45, 45)" }}
          />
          <div className="container">
            <div className="row heading">
              <div className="col-md-10">
                <h1 className="mbr-section-title display-3 heading-title">
                  投資心法
                </h1>
                <p className="mbr-section-subtitle text-1 heading-text">
                  1.價廉物美：投資成功的關鍵在於，當市場價格大大低於經營企業的價值時，買入優秀企業的股票。
                  <br />
                  2.不犯大錯：投資人並不需要做對很多事情，重要的是要能不犯重大的過錯。
                  <br />
                  3.安全邊際：架設橋樑時，你堅持載重量為3萬磅，但你只准許1萬磅的卡車穿梭其間。相同的原則也適用於投資領域。
                  <br />
                  <br />
                  沃倫 巴菲特
                  <br />
                </p>
              </div>
            </div>
          </div>
        </section>


        
        <section
          className="mbr-section accordion1"
          id="accordion1-2"
          data-rv-view={779}
          style={{
            backgroundColor: "rgb(255, 255, 253)",
            paddingTop: 100,
            paddingBottom: 100
          }}
        >
          <div style={{ textAlign: 'center', width: "100%" }}>
            <div style={{ display: 'inline-block' }}><a href="https://play.google.com/store/apps/details?id=com.stockdigger" target="_blank"><img width="200" src="android_download.png" /></a></div>
            <div style={{ display: 'inline-block' }}><a href="https://apps.apple.com/tw/app/%E8%82%A1%E7%A5%A8%E6%8C%96%E5%9C%9F%E6%A9%9F-%E6%89%BE%E8%A2%AB%E4%BD%8E%E4%BC%B0%E7%9A%84%E5%A5%BD%E8%82%A1%E7%A5%A8/id1481434455" target="_blank"><img width="200" src="apple_download.png" /></a></div>
          </div>
        </section>
        <section
          className="mbr-section accordion1"
          id="accordion1-5"
          data-rv-view={779}
          style={{
            backgroundColor: "rgb(255, 255, 253)",
            paddingTop: 100,
            paddingBottom: 100
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2">
                <div className="section-head text-center">
                  <h1 className="mbr-section-title display-2 text-center">
                    常見問題
                  </h1>
                </div>
                <div className="clearfix" />
                <div
                  id="accordion"
                  className="panel-group accordionStyles accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div className="accordion-group">


                    <div
                      className="panel panel-default colorBG"
                      style={{ display: "block" }}
                    >
                      <div className="panel-heading" role="tab" id="headingOne">
                        <span className="signSpan pseudoMinus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseOneaccordion1-5"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            <span className="sign" />
                            我想要的資料不存在挖土機裡面怎麼辦?
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseOneaccordion1-5"
                        className="panel-collapse noScroll collapse in"
                        role="tabpanel"
                        aria-labelledby="headingOne"
                      >
                        <div className="panel-body">
                          <p>
                            別擔心，麻煩利用<a href="index.html#form1-n">連絡我們</a>或者加入社團
                            將您想要的指標詳細的告訴我們,
                            我們會排定時間將它放入股票挖土機內。
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo1">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-16a"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            為何我建議的功能一直沒有看到?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-16a"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo1"
                      >
                        <div className="panel-body">
                          <p>
                            很感謝使用者都會提供寶貴的建議給股票挖土機，其中包含功能面，資料面或是操作介面上，但由於建議數量十分龐大再加上系統本身有主要的功能，
                            所以這些建議會依照有多人一直重複提出的先行開發，敬請見諒。歡迎隨時來信提醒。
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo1">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-6a"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            免費使用有什麼限制?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-6a"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo1"
                      >
                        <div className="panel-body">
                          <p>
                            1. 搜尋結果：免費者最多搜尋出10筆，購買方案後最多可以搜尋出150筆<br />
                            2. 特殊選股：免費者不能使用，購買方案後可以懶人選股，券商選股，行業別選股<br />
                            3. 手機廣告：免費者下方會有一條廣告，購買方案後無任何廣告<br />
                            4. 雲端同步：免費者自選股清單與選股策略電腦與手機不會同步，購買方案後會雙向同步<br />
                            最後，不管多少的是哪個方案都能讓系統更加倍努力的為您做事
                          </p>
                        </div>
                      </div>
                    </div>



                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo1">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-6"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            懶人選股最多都固定顯示50支股票?這是錯誤嗎?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-6"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo1"
                      >
                        <div className="panel-body">
                          <p>
                            是對的。懶人選股會依照您的條件找出最貼近的50筆
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo1">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-6c"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            資料都何時更新?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-6c"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo1"
                      >
                        <div className="panel-body">
                          <p>
                            因為資料眾多，公開資訊觀測站/證交所/櫃買中心等系統也沒有統一的更新時間，所以資料都是陸續完成更新。<br />
                            股價：盤中股價延遲30分鐘
                            日籌碼：晚上十點前更新完畢<br />
                            週籌碼：星期六中午十二點<br />
                            其他表格 (營收/....)：每日更新兩次，下午三點、晚上八點
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-7kk1"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            用信用卡，ATM轉帳，超商付款有什麼差別嗎?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-7kk1"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>
                            信用卡：完成付款後，3分鐘後自動解鎖<br />
                            ATM轉帳：完成付款後，10分鐘後自動解鎖<br />
                            超商付款：完成付款後，2-3天後自動解鎖，想加速解鎖請將超商收據寄到jookershop@gmail.com<br />
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-7kk4"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            為何付款方式沒有支援Google Pay或Apple Pay?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-7kk4"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>
                            目前會將開發重心放在選股功能，所以並沒有在多支援其他付款方式。另外，所有金流服務目前是委託給藍新科技負責，股票挖土機不經手也不存放任何付款資料，請安心使用。<br />
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-7kk5"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            購買方案後沒有解鎖怎麼辦?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-7kk5"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>
                            麻煩將大名，手機與相關繳費收據或信件轉寄到jookershop@gmail.com，會有專人為您服務<br />
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-7kk7"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            有些股票怎麼會找不到?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-7kk7"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>
                            目前僅支援上市與上櫃的股票。興櫃、公開發行與ETF都尚未支援<br />
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-7kk8"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            換手機該如何處理?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-7kk8"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>
                            請將現行的序號記錄下來並妥善保管，在新手機重新安裝後輸入相同序號即可<br />
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-7kk9"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            我如果有很多台手機或機器可以使用同一組序號嗎?可以同時使用嗎？&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-7kk9"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>
                            目前個人多款裝置同時使用上是沒有問題的。請妥善保管序號，切記不要公布給他人使用，以免之後限制台數或同時上線數量時自己卻無法使用。<br />
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-7kk10"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            無使用期限的方案，以後價格變動需要再多付錢嗎？以後的更新也都可以直接使用嗎？&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-7kk10"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>無使用期限的支持，以後的更新都可以直接使用，以後價格的變動都不需要再付任何款項。
                            。<br />
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-7kk11"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            無使用期限的方案，到底是可以使用多久？&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-7kk11"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>無使用期限的支持者，只要公司系統還存在的一天都可以一直使用下去。
                            。<br />
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-7kk13"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            2021上半年還有什麼新功能嗎？&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-7kk13"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>
                            2020下半年的三大主要功能初步都完成了<br />
                            回測系統：好的股票策略需要回測系統來驗證<br />
                            加入ETF：此類交易越來越多人加入<br />
                            型態選股：技術面重要的工具<br />

                            2021上半年主要的功能有
                            1. 個人預測分享
                            2. 盤中搜尋
                            3. 明細的所有圖表呈現
                          </p>
                        </div>
                      </div>
                    </div>




                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-7kk12"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            有計畫開發盤中的分析嗎？&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-7kk12"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>
                            盤中資料一個月需要花費六萬元才能取得，目前股票挖土機尚未有長期負擔這項成本的能力，半年後再評估。<br />
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-7kk17"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            何時有活動？何時會打折？&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-7kk17"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>
                            股票挖土機是盡量不進行促銷活動（頂多一年2次），也就是今天的價格都會是以後的最低價。
                            這是對所有的支持者在股票挖土機功能尚未完備時，卻還是願意大力訂閱所表達的謝意與尊重。<br />
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-7kk21"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            方案價格會往上漲價嗎？&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-7kk21"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>
                            會的。每次完成主要功能後，會進行評估價格是否合理。<br />
                            訂閱新舊方案交替時，舊方案會維持一段時間，請把握最後的機會。
                            訂閱方案若無人使用時，過段時間就會重新設計。<br />
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-7kk2"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            想取消每個月的訂閱該怎麼做?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-7kk2"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>
                            麻煩將大名與手機後五碼或序號寄到jookershop@gmail.com，會有專人為您服務<br />
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-7"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            在電腦上面購買完成後，如何在手機上面使用?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-7"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>
                            訂閱完成後會自動解鎖 ，序號會出現在方案價格頁面的最上方。如需要在新的裝置(電腦或手機)上使用 ，將此碼輸入至相同的地方即可完成解鎖。
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo2">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#ccollapseTwoaccordion1-7a"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            是否有私密的FB社團討論相關的策略設置呢?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="ccollapseTwoaccordion1-7a"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="panel-body">
                          <p>
                            目前<a href="https://www.facebook.com/groups/508460833089268/">社團</a>與<a href="https://www.facebook.com/%E8%82%A1%E7%A5%A8%E6%8C%96%E5%9C%9F%E6%A9%9F-102085821284963/?ref=bookmarks">粉絲頁</a>都是剛剛成立沒有多久，歡迎加入討論。
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-5"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            有技術分析的指標嗎?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-5"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo"
                      >
                        <div className="panel-body">
                          <p>
                            有的。目前有MACD、KD、RSI、均線、布林通道、糾結線、乖離率、葛蘭碧八大法則等相關技術分析，其他的會在陸續開發。
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-9a"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            有籌碼相關的指標嗎?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-9a"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo"
                      >
                        <div className="panel-body">
                          <p>
                            有的。目前有主力、大戶、散戶、中實戶、內部大戶、三大法人、分點券商、官股等相關籌碼，其他的會在陸續開發。
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-99a"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            搜尋後的表格，不希望有兩個卷軸，該如何處理?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-99a"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo"
                      >
                        <div className="panel-body">
                          <p>
                            可以到自選股清單點選"功能"按鈕，在選擇"表頭固定/解除"就可以剩下一個卷軸。
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingTwo">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseTwoaccordion1-199a"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            Android版的股票挖土機一直會出現無回應，該如何處理?&nbsp;
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseTwoaccordion1-199a"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingTwo"
                      >
                        <div className="panel-body">
                          <p>
                            Android系統只要您一直對畫面進行操作，如果系統剛好在忙碌中，超過0.5秒沒有回應就會跳出警告，這是目前股票挖土機使用技術(webview)上的限制，除了放慢操作速度試試看或等等再進行查詢外，暫時還沒有解法，可能要等之後改寫才會改善，十分抱歉。
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingThree">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseThreeaccordion1-5"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            我可以直接透過股票挖土機下單嗎?
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseThreeaccordion1-5"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingThree"
                      >
                        <div className="panel-body">
                          <p>
                            不可以。股票挖土機是一個讓您方便快速的挖出寶藏的工具，看盤或者下單都不是他的範疇。
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingThree">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseFouraccordion1-5"
                            aria-expanded="false"
                            aria-controls="collapseFour"
                          >
                            如果發現資料有誤怎麼辦?
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseFouraccordion1-5"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingThree"
                      >
                        <div className="panel-body">
                          可以透過"<a href="ndex.html#form1-n">聯絡我們</a>
                          "來告訴我們。如果要詳細又正確的資料請參閱
                          <a
                            href="https://mops.twse.com.tw/mops/web/index"
                            target="_blank"
                          >
                            公開資訊觀測站
                          </a>
                          、
                          <a href="https://www.twse.com.tw/zh/" target="_blank">
                            證交所
                          </a>
                          、
                          <a
                            href="https://www.tpex.org.tw/web/index.php?l=zh-tw"
                            target="_blank"
                          >
                            證券櫃檯買賣中心
                          </a>
                          &nbsp;三個網站。
                        </div>
                      </div>
                    </div>
                    <div className="panel panel-default" style={{ display: "block" }}>
                      <div className="panel-heading" role="tab" id="headingThree">
                        <span className="signSpan pseudoPlus" />
                        <h4 className="panel-title">
                          <a
                            role="button"
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion1-5-init"
                            data-core
                            href="#collapseSixaccordion1-5"
                            aria-expanded="false"
                            aria-controls="collapseSix"
                          >
                            可以在手機上執行股票挖土機嗎?
                          </a>
                        </h4>
                      </div>
                      <div
                        id="collapseSixaccordion1-5"
                        className="panel-collapse noScroll collapse"
                        role="tabpanel"
                        aria-labelledby="headingThree"
                      >
                        <div className="panel-body">
                          可以。<br />
                          <b>iOS</b>
                          <a href="https://apps.apple.com/us/app/%E8%82%A1%E7%A5%A8%E6%8C%96%E5%9C%9F%E6%A9%9F-%E6%89%BE%E8%A2%AB%E4%BD%8E%E4%BC%B0%E7%9A%84%E5%A5%BD%E8%82%A1%E7%A5%A8/id1481434455?l=zh&ls=1" target="_blank">下載</a>
                          <br />
                          <b>Android版</b>
                          <a href="https://play.google.com/store/apps/details?id=com.stockdigger" target="_blank">下載</a>
                          <br />
                          <b>網頁版 (電腦/Android/iOS 都適用)</b>
                          <a href="https://stock-digger.com/#/rules" target="_blank">開啟</a>


                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="mbr-section mbr-section-hero form1"
          id="form1-n"
          data-rv-view={786}
          style={{
            backgroundColor: "rgb(255, 255, 253)",
            paddingTop: 40,
            paddingBottom: 40
          }}
        >
          <div className="container">
            <div className="row heading">
              <div className="col-md-12 text-xs-center">
                <h1 className="mbr-section-title display-3 heading-title">
                  <p>聯絡我們</p>
                  <br />
                  <p>
                    <br />
                  </p>
                </h1>
                <p className="mbr-section-subtitle text-1 heading-text">
                  有任何問題都可以直接寫信到
                  <a href="mailto:jookershop@gmail.com">jookershop@gmail.com</a>， 我們會盡快的回覆您。
                </p>
              </div>
            </div>
          </div>
          {/* <div className="container">
      <div className="col-xs-12 form">
        <div className="row" data-form-type="formoid">
        <div data-form-alert="true" hidden data-form-alert-success="true" className="alert alert-form alert-success text-xs-center">
                  謝謝您的來信，我們會盡快的替您處理。
                    </div>
          <form
            action="https://mobirise.com/"
            method="post"
            data-form-title="聯絡我們"
          >
            <input
              type="hidden"
              defaultValue="w3CVsGTlNMhaWgklpq4DLnH5MZD0Pn7tqqO3h4pNMp670LgJjUgshUUpqgq0lSWfWmcyiiKgWqo/lGeMp/zxUyHNy9suORAADvGBlVcLxY7a8feqXY72i0NoAK1R1UtJ.U5Br8obtUkMmLSmhNPDLyFaM62pCtDcKD/NHBxsWHAAbXTif7/IvttTNoDtIvWHItfFt+6b7Is7ooqxbc96tbLJqjPjHKg5oKvIE1Lwi4RP9dWCoIzSqpfRC7b4K9m1Q"
              data-form-email="true"
            />
            <div className="col-xs-12 col-md-8 col-md-offset-2 form-wrap">
              <div className="col-xs-12">
                <div className="form-group">
                  <label className="form-control-label">姓名*</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    required
                    data-form-field="Name"
                    placeholder="姓名*"
                  />
                </div>
              </div>
              <div className="col-xs-12">
                <div className="form-group">
                  <label className="form-control-label">電子郵件*</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    required
                    data-form-field="Email"
                    placeholder="電子郵件*"
                  />
                </div>
              </div>
              <div className="col-xs-12">
                <div className="form-group">
                  <label className="form-control-label">電話</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="phone"
                    data-form-field="Phone"
                    placeholder="電話"
                  />
                </div>
              </div>
              <div className="col-xs-12">
                <label className="form-control-label">內容</label>
                <textarea
                  className="form-control"
                  name="message"
                  rows={7}
                  data-form-field="Message"
                  placeholder="無法解鎖或遺失碼者請提供藍新訂單完成信件或超商收據寄到jookershop@gmail.com以利補發"
                  defaultValue={""}
                />
              </div>
            </div>
            <div className="clear" />
            <div className="form-separator" />
            <div className="col-xs-12 col-md-8 col-md-offset-2 form-button-wrap">
              <div className="text-xs-center text-md-right">
                <button type="submit" className="btn btn-lg btn-primary">
                  送出訊息
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div> */}
        </section>
        <footer
          className="mbr-small-footer mbr-section mbr-section-nopadding footer4"
          id="footer4-9"
          data-rv-view={782}
          style={{
            backgroundColor: "rgb(255, 255, 255)",
            paddingTop: "0rem",
            paddingBottom: "0rem"
          }}
        >
          <div className="container">
            <p className="text-xs-center">Copyright (c) 2019 喬可小舖.</p>
          </div>
        </footer>
      </div>

    );
  }
}



export default withRouter(withStyles(styles)(Home));